import React, { useEffect, useState } from 'react'
import "react-datepicker/dist/react-datepicker.css";
import CapacityAllocation from './CapacityAllocation';

const CapacityAllocationPROJECT = () => {
    return (<>
        <CapacityAllocation type='PROJECT' />
    </>)
}
export default CapacityAllocationPROJECT;